import React from "react";
import SharedModal from "./SharedModal";
import {
  MYTASSEL_PLUS_BENEFITS,
  getMyTasselPlusFeatureLabel,
} from "../constants/MyTasselPlus";

const MyTasselPlusUpsellModal = ({
  isVisible,
  onClose,
  onCta,
  feature,
  isLoading = false,
  errorMessage = "",
}) => {
  const featureLabel = getMyTasselPlusFeatureLabel(feature);

  return (
    <SharedModal
      isVisible={isVisible}
      onClose={onClose}
      title="Make it yours with MyTassel+"
      confirmText={isLoading ? "Opening..." : "Make it my own"}
      cancelText="Not now"
      onConfirm={onCta || onClose}
      confirmButtonStyle={styles.primaryButton}
      cancelButtonStyle={styles.secondaryButton}
    >
      <div style={styles.body}>
        <div style={styles.intro}>
          Unlock {featureLabel} and more ways to personalize your graduation page.
        </div>
        <div style={styles.list}>
          {MYTASSEL_PLUS_BENEFITS.map((benefit) => (
            <div key={benefit} style={styles.item}>
              <span style={styles.check}>+</span>
              <span>{benefit}</span>
            </div>
          ))}
        </div>
        {errorMessage ? (
          <div style={styles.error}>
            {errorMessage}
          </div>
        ) : null}
      </div>
    </SharedModal>
  );
};

const styles = {
  body: {
    textAlign: "left",
    fontFamily: "Orpheus Pro, serif",
  },
  intro: {
    color: "#333",
    fontSize: 16,
    lineHeight: 1.5,
    marginBottom: 14,
    textAlign: "center",
  },
  list: {
    display: "grid",
    gap: 8,
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    color: "#2d5a3f",
    fontSize: 15,
  },
  check: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: "#4c956c",
    color: "#fefde2",
    fontWeight: 700,
    flex: "0 0 auto",
  },
  error: {
    color: "#8f2f2f",
    fontSize: 14,
    lineHeight: 1.4,
    marginTop: 14,
    textAlign: "center",
  },
  primaryButton: {
    backgroundColor: "#4c956c",
    border: "1px solid #4c956c",
    color: "#fefde2",
  },
  secondaryButton: {
    backgroundColor: "transparent",
    border: "1px solid rgba(76, 149, 108, 0.55)",
    color: "#4c956c",
  },
};

export default MyTasselPlusUpsellModal;
